import { memo, useEffect, useState } from 'react';

import Alert from './Alert';
import * as S from './styled/ToastManager.styled';

/**
 * @author @buunsal
 *
 */

export let ToastList = [];

const Toast = (props) => {
	const { id, type, header, message, link, linkAction, persist, onClose } = props;

	const [showing, setShowing] = useState(true);
	const [exiting, setExiting] = useState(false);

	const closeAlert = () => {
		ToastList = ToastList?.filter((item) => item.id !== id);
		window.dispatchEvent(new Event('updateToastList'));
		onClose && onClose();
	};

	const handleCloseAction = () => {
		setExiting(true);
		setTimeout(() => {
			closeAlert();
		}, 600);
	};

	const handleLinkAction = () => {
		linkAction && linkAction();
		closeAlert();
	};

	useEffect(() => {
		if (link !== undefined || persist) {
			return;
		}

		const timer = setTimeout(() => {
			setShowing(false);
		}, 600);

		const timer2 = setTimeout(() => {
			setExiting(true);
			setTimeout(() => {
				closeAlert();
			}, 600);
		}, 7000);

		return () => {
			timer && clearTimeout(timer);
			timer2 && clearTimeout(timer2);
		};
	}, []);

	return (
		<S.ToastWrapper
			className={`${showing ? 'showing' : ''} ${exiting ? 'exiting' : ''}`}
			onMouseDown={(event) => event.stopPropagation()}
			onTouchEnd={(event) => event.stopPropagation()}>
			<Alert
				variant={type}
				compact={false}
				showIcon
				header={header}
				content={message}
				ctaButtonLabel={link}
				onCtaButtonClick={handleLinkAction}
				onClose={handleCloseAction}
			/>
		</S.ToastWrapper>
	);
};

const MemoizedToast = memo(Toast);

const ToastManager = () => {
	const [toastArr, setToastArr] = useState([...ToastList].slice(0, 3));

	const handleToastListChange = () => {
		setToastArr([...ToastList].slice(0, 3));
	};

	useEffect(() => {
		window.addEventListener('updateToastList', handleToastListChange);

		return () => {
			window.removeEventListener('updateToastList', handleToastListChange);
		};
	}, []);

	return (
		<S.ToastManagerContainer>
			{toastArr.reverse().map((alert) => (
				<MemoizedToast key={alert.id} {...alert} />
			))}
		</S.ToastManagerContainer>
	);
};

export default ToastManager;
